import script from "./LargeModal.vue?vue&type=script&setup=true&lang=js"
export * from "./LargeModal.vue?vue&type=script&setup=true&lang=js"

import "./LargeModal.vue?vue&type=style&index=0&id=6cf34e67&lang=css"

const __exports__ = script;

export default __exports__